import React, { useState } from 'react';
import fr from 'facet-rest';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import LeftNav
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/AllNotes/AllNotes/LeftNav';
import CombinedNotes
  from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/AllNotes/AllNotes/CombinedNotes';
import { NoteListContextProvider } from './NoteListContext';

const styles = () => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
    overflowY: 'hidden',
  },
});

const AllNotesView = ({
  className,
  classes,
  ...rest
}) => {
  const { rootNodeProps } = useEventTrackingLogEvent({
    nodeName: 'All Notes Tab',
    isPageView: true,
  });

  const [selectedNote, setSelectedNote] = useState('');
  const [scrollTo, setScrollTo] = useState('');

  const householdContext = useSimpleHousehold();
  const { householdResource } = householdContext;

  return (
    <NoteListContextProvider
      notesSelfLink={householdResource?.relationship(fr.relationships.allNotes.name)?.link('related').url()}
    >
      <div
        className={classNames(classes.root, className)}
        {...rest}
        {...rootNodeProps}
      >
        <LeftNav selectedNote={selectedNote} setScrollTo={setScrollTo} />
        <CombinedNotes setSelectedNote={setSelectedNote} selectedNote={selectedNote} setScrollTo={setScrollTo} scrollTo={scrollTo} />
      </div>
    </NoteListContextProvider>
  );
};

AllNotesView.defaultProps = {
  className: '',
};

AllNotesView.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(AllNotesView);
